import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";


const AutombilePolicyUpdates = Loadable(
  lazy(() =>
    import("./AutomobilePolicyUpdates").then(({ AutombilePolicyUpdates }) => ({
      default: AutombilePolicyUpdates,
    }))
  )
);

export const AutombilePolicyUpdatesRoutes = [
  {
    path: `/automobile-policy/:customerId/updates/:customerPolicyId`,
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <AutombilePolicyUpdates />
      </AuthorizedRoute>
    ),
  },
]